import api from "../../APIIntercepter";

async function getAllBankSlipsAPI(classId, status) {
  const res = await api.get(`/bankslip/admin/getAllBankSlips/${classId}/${status}`);
  return res.data;
}

async function getBankSlipsAPI(studentId, status) {
  const res = await api.get(`/bankslip/admin/${studentId}/${status}`);
  return res.data;
}

async function approveBankSlipAPI(id) {
  const res = await api.put(`/bankslip/admin/approve/${id}`);
  return res.data;
}

async function rejectBankSlipAPI(id) {
  const res = await api.put(`/bankslip/admin/reject/${id}`);
  return res.data;
}

async function getAllSeminarPaymentsAPI(seminarId,status) {
  const res = await api.get(`/studentseminarassign/admin/getStudentSeminar/${seminarId}/${status}`);
  return res.data;
}

async function approveSeminarPaymentAPI(id) {
  const res = await api.put(`/studentseminarassign/admin/approve/${id}`);
  return res.data;
}

async function rejectSeminarPaymentAPI(id) {
  const res = await api.post(`/studentseminarassign/admin/reject/${id}`);
  return res.data;
}

async function getAllCoursePaymentsAPI(courseId, status) {
  const res = await api.get(`/studentcourseassign/admin/getStudentCourse/${courseId}/${status}`);
  return res.data;
}

async function approveCoursePaymentAPI(id) {
  const res = await api.put(`/studentcourseassign/admin/approve/${id}`);
  return res.data;
}

async function rejectCoursePaymentAPI(id) {
  const res = await api.post(`/studentcourseassign/admin/reject/${id}`);
  return res.data;
}

export {
  getAllBankSlipsAPI,
  getBankSlipsAPI,
  approveBankSlipAPI,
  rejectBankSlipAPI,
  getAllSeminarPaymentsAPI,
  approveSeminarPaymentAPI,
  rejectSeminarPaymentAPI,
  getAllCoursePaymentsAPI,
  approveCoursePaymentAPI,
  rejectCoursePaymentAPI,
};
